export const headerLinks = [
    {
        id: 'home',
        pathname: '/result' || '/progress',
        label: 'Last Session',
        parent: 0
    },
    {
        id: 'courses',
        pathname: '/courses',
        label: 'Courses',
        parent: 0
    },
    {
        id: 'plans',
        pathname: '/plans',
        label: 'Memberships',
        parent: 0
    },
    {
        id: 'shop',
        pathname: 'https://japa.health/offerings',
        label: 'Shop',
        parent: 0
    },
    {
        id: 'history',
        pathname: '/history',
        label: 'Assessments',
        parent: 1
    },
    {
        id: 'payHistory',
        pathname: '/payHistory',
        label: 'Payment History',
        parent: 1
    },
    {
        id: 'community',
        pathname: 'https://japa.health/members',
        label: 'Community',
        parent: 0
    },
    {
        id: 'events',
        pathname: 'https://japa.health/events',
        label: 'Events',
        parent: 0
    }
]